// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2IcO4","content":"styles_content__LJPea"};